import { useNavigate } from "react-router-dom";
import { useCallback, startTransition } from "react";
import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import syndicateHero from "@/assets/horsebeat-clenove-kun.jpg.asset.json";
import racingHero from "@/assets/tipy-na-dostihy-hero.jpg.asset.json";

export const HomepageTiles = () => {
  const navigate = useNavigate();

  const handleNavigate = useCallback((path: string) => {
    startTransition(() => navigate(path));
  }, [navigate]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-5">
      {/* Spolumajitelství — dominantní 2/3 */}
      <Card
        className="group relative overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-0.5 border border-border rounded-2xl shadow-none md:col-span-2"
        onClick={() => handleNavigate("/syndicates")}
      >
        <div className="relative h-[340px] md:h-[480px]">
          <img
            src={syndicateHero.url}
            alt="Fanoušci a spolumajitelé při setkání s dostihovým koněm"
            className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
            fetchPriority="high"
            decoding="async"
            width={1920}
            height={1280}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

          <div className="relative h-full p-7 md:p-10 flex flex-col justify-end text-white">
            <span className="kicker mb-3" style={{ color: "hsl(var(--accent))" }}>
              Spolumajitelství koně
            </span>
            <h2 className="display-xl text-white mb-3 max-w-2xl text-balance">
              Váš kůň. Vaše barvy. Vaše sezóna.
            </h2>
            <p className="text-base md:text-lg text-white/85 mb-5 leading-relaxed max-w-xl font-body">
              Podíl v koni, jméno na startovce a přístup do zákulisí. Zážitkové členství pro fanoušky dostihů — od 2 490 Kč (99 EUR).
            </p>

            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-5 py-2.5 rounded-lg transition-all group-hover:gap-3">
                Prohlédnout koně
                <ArrowRight className="h-4 w-4" />
              </span>
              <span className="text-sm text-white/70">
                Aktivní syndikáty · sezóna 2027 · jednorázová platba
              </span>
            </div>
          </div>
        </div>
      </Card>

      {/* Tipy — sekundární 1/3 */}
      <Card
        className="group relative overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-0.5 border border-border rounded-2xl shadow-none"
        onClick={() => handleNavigate("/tipy-na-dostihy")}
      >
        <div className="relative h-[220px] md:h-[480px]">
          <img
            src={racingHero.url}
            alt="Tipy na dostihy - statistiky koní a žokejů"
            className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
            fetchPriority="high"
            decoding="async"
            width={480}
            height={480}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-transparent" />

          <div className="relative h-full p-6 md:p-7 flex flex-col justify-end text-white">
            <span className="kicker mb-2" style={{ color: "hsl(var(--accent))" }}>
              Zdarma
            </span>
            <h2 className="font-display text-2xl md:text-[1.75rem] font-semibold leading-[1.1] tracking-tight mb-2">
              Tipy, statistiky a databáze dostihů
            </h2>
            <p className="text-sm text-white/80 mb-4 leading-relaxed font-body">
              Porovnejte koně a jezdce, sledujte statistiky a tipujte na nadcházející dostihy.
            </p>
            <div className="inline-flex items-center gap-2 font-medium group-hover:gap-3 transition-all w-fit border-b border-white/40 pb-1">
              <span className="text-sm">Začít tipovat</span>
              <ArrowRight className="h-4 w-4" />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
